<template>
  <div class="form-input-text">
    <el-row>
      <el-col :span="12">
        <el-input
           v-model="text.value"
           type="textarea"
           autosize
           class="w-100"
          :disabled="disabled"
          @change="updateText">
        </el-input>
      </el-col>
      <el-col :span="24" v-if="input.description">
        <div class="el-form-item__help">
          <p>{{ input.description }}</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { isNil, get } from 'lodash';

export default {
  name: 'form-input-text',
  props: {
    input: {
      type: Object,
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      text: {
        id: null,
        code: null,
        value: null,
      },
    };
  },
  methods: {
    updateText() {
      this.$emit('set:value', {
        code: this.text.code,
        data: {
          id: this.text.id,
          value: this.text.value,
        },
      });
    },
  },
  created() {
    const value = get(this.input, 'value');
    this.text.id = this.input.id;
    this.text.code = this.input.code;
    this.text.value = value;
    if (!isNil(value)) this.updateText();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/category-questionnaire/form-input/cmpt-form-input-text.vue